import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  vehicleInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
    '&.infoAlignRight': {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: 0,
    },
    '& .vehicleImg': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 60,
      width: 60,
      height: 60,
      borderRadius: 8,
      marginInlineEnd: '8px',
    },
    '& .assetInfo-name a': {
      color: theme.new.color.textPrimary,
    },
    '& .assetInfo': {
      width: 'calc(100% - 68px)',
      '&.noImage': {
        width: '100%',
      },
      '& > div': {
        lineHeight: '1em',
        '& span': {
          lineHeight: '1.5em',
        },
      },
    },
    '& .mobileView': {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  vehicleDetails: {
    color: theme.new.color.textSecondary,
  },
}));

export default useStyles;
